var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-326 -122)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(326 122)",
    fill: "#272e45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M6.264,3.039a2,2,0,0,1,3.473,0l4.554,7.969A2,2,0,0,1,12.554,14H3.446A2,2,0,0,1,1.71,11.008Z",
    transform: "translate(352 131.474) rotate(90)",
    fill: "#7d828f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBlue);
export default __webpack_public_path__ + "static/media/playBlue.65032a9db2b95b2aa85ddfa57a004bb9.svg";
export { ForwardRef as ReactComponent };